"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    return {
      pageName: 'messagePush',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      dialogStatus: 'create',
      errorKeys: [],
      errorInfo: {},
      appPushTypeOption: [{
        configItem: {
          configItemName: ''
        }
      }, {
        configItem: {
          configItemName: ''
        }
      }],
      lookupList: {},
      searchVal: {
        appNotifyContent: '',
        appPushUsers: '',
        userName: '',
        resultStatus: '',
        appPushType: '',
        appNotifyStartTime: null,
        appNotifyEndTime: null
      },
      startPickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },
        selectableRange: '00:00:00 - 23:59:59'
      },
      endPickerOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.appNotifyStartTime) {
            return time.getTime() <= new Date(_this.searchVal.appNotifyStartTime).getTime() - 3600 * 1000 * 24;
          }
        },
        selectableRange: '00:00:00 - 23:59:59'
      },
      messagePkList: [],
      visitRetailorRecordPkList: []
    };
  },
  computed: {
    startTime: function startTime() {
      return this.searchVal.appNotifyStartTime;
    }
  },
  watch: {
    startTime: function startTime(nval, oval) {
      var date = new Date(nval);
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      this.endPickerOptions.selectableRange = "".concat(hours, ":").concat(minute, ":").concat(second, " - 23:59:59");
    },
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.getLookupTypeCode();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          appNotifyContent: this.searchVal.appNotifyContent,
          appPushUsers: this.searchVal.appPushUsers,
          userName: this.searchVal.userName,
          resultStatus: this.searchVal.resultStatus,
          appPushType: this.searchVal.appPushType,
          appNotifyStartTime: this.searchVal.appNotifyStartTime,
          appNotifyEndTime: this.searchVal.appNotifyEndTime
        }
      };
      this.listLoading = true;
      this.$api.messagePush.getList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    rePushBatchMsgData: function rePushBatchMsgData() {
      var _this3 = this;
      if (this.messagePkList.length === 0 && this.visitRetailorRecordPkList.length === 0) {
        this.$message.error(this.$t('messagePush.message.errorTips'));
        return;
      }
      this.$confirm(this.$t('messagePush.message.confirmTips'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        if (_this3.sourceApi) {
          _this3.sourceApi.cancel('cancel');
        }
        _this3.sourceApi = _axios.default.CancelToken.source();
        var param = {
          messagePkList: _this3.messagePkList,
          visitRetailorRecordPkList: _this3.visitRetailorRecordPkList
        };
        _this3.$api.messagePush.rePushBatchMsg(param, _this3.sourceApi.token).then(function (res) {
          console.log(res);
          if (res.success) {
            _this3.$message.success(_this3.$t('messagePush.common.S'));
            _this3.fetchData();
          } else {
            _this3.$message.error(_this3.$t('messagePush.common.F'));
          }
        }).catch(function (err) {
          if (_axios.default.isCancel(err)) {
            return false;
          }
        });
      }).catch(function () {});
    },
    rePush: function rePush(val) {
      var _this4 = this;
      this.$confirm(this.$t('messagePush.message.confirmTips'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        if (_this4.sourceApi) {
          _this4.sourceApi.cancel('cancel');
        }
        _this4.sourceApi = _axios.default.CancelToken.source();
        var messagePkList = [];
        var visitRetailorRecordPkList = [];
        if (val.regularMessageSendRecordPk) {
          messagePkList.push(val.regularMessageSendRecordPk);
        }
        if (val.customerVisitRetailorRecordDetailPk) {
          visitRetailorRecordPkList.push(val.customerVisitRetailorRecordDetailPk);
        }
        var param = {
          messagePkList: messagePkList,
          visitRetailorRecordPkList: visitRetailorRecordPkList
        };
        _this4.$api.messagePush.rePushBatchMsg(param, _this4.sourceApi.token).then(function (res) {
          console.log(res);
          if (res.success) {
            _this4.$message.success(_this4.$t('messagePush.common.S'));
            _this4.fetchData();
          } else {
            _this4.$message.error(_this4.$t('messagePush.common.F'));
          }
        }).catch(function (err) {
          if (_axios.default.isCancel(err)) {
            return false;
          }
        });
      }).catch(function () {});
    },
    resetData: function resetData() {
      this.searchVal = {
        appNotifyContent: '',
        appPushUsers: '',
        userName: '',
        resultStatus: '',
        appPushType: '',
        appNotifyStartTime: null,
        appNotifyEndTime: null
      };
      this.fetchData();
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this5 = this;
      var param = {
        configItemCodeList: ['MESSAGE_TYPE', 'MESSAGE_PUSH_STATUS']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this5.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this5.lookupList) {
          _this5.generateMapping(key, _this5.lookupList[key] || []);
        }
        _this5.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this6 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this6.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this7 = this;
      // console.log('当前选中项', val)
      this.messagePkList = [];
      this.visitRetailorRecordPkList = [];
      val.forEach(function (item, index) {
        if (item.regularMessageSendRecordPk) {
          _this7.messagePkList.push(item.regularMessageSendRecordPk);
        }
        if (item.customerVisitRetailorRecordDetailPk) {
          _this7.visitRetailorRecordPkList.push(item.customerVisitRetailorRecordDetailPk);
        }
      });
      // console.log('当前选中项', this.messagePkList)
      // console.log('当前选中项', this.visitRetailorRecordPkList)
    }
  }
};